const SHOWCASE_IMG =
  "https://images.unsplash.com/photo-1581092795442-d153057d8e0d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHx0ZWNoJTIwaGFyZHdhcmUlMjBzdHVkaW98ZW58MHx8fHwxNzkyNzQzMzU5fDA&ixlib=rb-4.1.0&q=85";

export default function Showcase() {
  return (
    <section
      id="ecosystem"
      data-testid="showcase-section"
      className="border-y border-[#24283b] relative overflow-hidden py-24 bg-[#0a0d14]"
    >
      <div className="absolute inset-0">
        <img
          src={SHOWCASE_IMG}
          alt="High-tech hardware synthesis studio with laser cutter and web workstations"
          data-testid="showcase-image"
          className="w-full h-full object-cover opacity-30 img-drift"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0b0c10] via-transparent to-[#0b0c10]"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
        <div className="md:col-span-8">
          <span className="font-mono-goat text-xs uppercase tracking-widest text-[#45f3ff]">
            Hardware + Software Fusion
          </span>
          <h3 className="font-display text-3xl md:text-5xl uppercase tracking-tight text-white mt-2 leading-none">
            From Raw Geometry To Scaled Online Revenue
          </h3>
          <p className="text-neutral-300 text-sm mt-4 max-w-xl">
            Stop coordinating five different vendors. GOAT Productions controls the exact continuum
            from 3D print file to physical delivery to live digital checkout.
          </p>
        </div>
        <div className="md:col-span-4 flex flex-col gap-3">
          <div className="p-4 bg-black/60 border border-[#24283b]">
            <span className="font-mono-goat text-[10px] text-neutral-400 uppercase tracking-widest">
              Delivery Radius
            </span>
            <p className="font-mono-goat text-sm text-white font-bold">
              Nationwide • Remote Worldwide
            </p>
          </div>
          <div className="p-4 bg-black/60 border border-[#24283b]">
            <span className="font-mono-goat text-[10px] text-neutral-400 uppercase tracking-widest">
              Production Cycle
            </span>
            <p className="font-mono-goat text-sm text-[#45f3ff] font-bold">Concept to Deployment</p>
          </div>
        </div>
      </div>
    </section>
  );
}
